module.exports = __webpack_public_path__ + "static/media/logo_exmimbank.36dcdbd3.svg";